<template>
  <div class="addExamineFile">
    <Modal
      v-model="addExamineFileState"
      width="950"
      title="上传附件">
        <uploadFile group_id="sczykh_yszgz" :teacherId="teacherIds" />
        <uploadFile group_id="sczykh_yszyz" :teacherId="teacherIds" />
        <uploadFile group_id="sczykh_zljszm" :teacherId="teacherIds" />
        <div slot="footer" style="text-align:center">
            <Button type="primary" @click="addExamineFileState=false" class="step2UploadBtn">确定</Button>
        </div>
    </Modal>
  </div>
</template>
<script>
import uploadFile from "@/views/declare/base/step2/uploadFile";
export default {
  props: {
    modalState: {
      type: Boolean,
      default() {
        return false;
      }
    },
    teacherNew: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      addExamineFileState: false,
      addExamineFileTitle: "",
      teacherIds: ""
    };
  },
  components: {
    uploadFile
  },
  watch: {
    modalState() {
      this.addExamineFileState = true;
    },
    teacherNew: {
      handler(obj) {
        this.teacherIds = obj.id;
      },
      deep: true
    }
  }
};
</script>